import { render } from "./EmailDetail.vue?vue&type=template&id=0da74128&scoped=true"
import script from "./EmailDetail.vue?vue&type=script&lang=js"
export * from "./EmailDetail.vue?vue&type=script&lang=js"

import "./EmailDetail.vue?vue&type=style&index=0&id=0da74128&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da74128"]])

export default __exports__